import React, { useState, useRef, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';
import { BotonBorrar } from '../../Utils/BotonBorrar';
import { BotonVerpdf } from '../../Utils/BotonVerpdf';
import { FaUpload } from 'react-icons/fa';

export default function SubirArchivo(){
    const { token, user, rol } = useAuth();
    const { idCabezaFamilia } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [nombre, setNombre] = useState('');
    const [swalProps, setSwalProps] = useState({});
    const [fechaCreacionCabeza, setFechaCreacionCabeza] = useState('');
    const [carpetaarchivo, setCarpetaarchivo] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const [integrantes, setIntegrantes] = useState([]);
    const [carArchivocentral, setCarArchivocentral] = useState(false);
    const [carArchivoubicado, setCarArchivoubicado] = useState('');
    const [envioBase64, setEnvioBase64] = useState(false);
    const ref = useRef();
    const [observacion, setObservacion] = useState('');
    const [archivos, setArchivos] = useState([]);
    const {register, handleSubmit, setValue, watch, formState: { errors }} = useForm();
    const onSubmit = async (data) => {
        await consultarCarpetaPersona(data.identificacion);
      };
    async function consultarCarpetaPersona(idPersona){
        if(idPersona === '' || idPersona === '0') return;
        setCargando(true);
        try {
            const response = await apiService.post('/archivo/consultarcarpetapersona', {idCabezaFamilia: idPersona}, token);
            const result = await response.data;
            setNombre(result.cabezafamilia.nombre);
            setFechaCreacionCabeza(result.cabezafamilia.cab_fechacreacion);
            setIntegrantes(result.integrantes);
            setArchivos(result.archivos);
            if(result.carpetaArchivoPersonaDTO.id){
                setCarpetaarchivo(result.carpetaArchivoPersonaDTO);
            }else{
                setCarpetaarchivo();
            }
            
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setCargando(false);
        }
    }
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    const handleUpload = async () => {
        if (!selectedFile) return;
        setCargando(true);
        const url = '/archivo/upfilepdf';
        let response;
        try {
            if(envioBase64){
                // 1. Read file as base64
                const toBase64 = file => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result.split(',')[1]); // Only base64 part
                    reader.onerror = error => reject(error);
                });

                const base64String = await toBase64(selectedFile);

                // 2. Prepare payload (example for JSON)
                const payload = {
                    fileName: selectedFile.name,
                    fileType: selectedFile.type,
                    contentBase64: base64String,
                    observacion,
                    IdCabezaFamilia: idCabezaFamilia,
                    perIdPersona: watch('per_idpersona'),
                    usrId: user,
                    carArchivocentral,
                    carArchivoubicado
                };

                // 3. Send to backend (adjust endpoint as needed)

                response = await apiService.post(url, payload, token);

            } else {
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('observacion', observacion);
                formData.append('IdCabezaFamilia', idCabezaFamilia);
                formData.append('perIdPersona', watch('per_idpersona'));
                formData.append('usrId', user);  
                formData.append('carArchivocentral', carArchivocentral);
                formData.append('carArchivoubicado', carArchivoubicado);
                response = await apiService.uploaddoc(url, formData, token);
            }
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }else{
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
            
        } finally {
            setCargando(false);
            ResetForm();
        }
    }; 
    const ResetForm = () => {
        ref.current.value = "";
        setSelectedFile(null);
        setObservacion('');
        onSubmit({identificacion: idCabezaFamilia});
    }
    const handleObservacion = (event) => {
        setObservacion(event.target.value);
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    function BorrarArchivo (row){
        setSwalProps({
            show: true,
            title: '¿Está seguro?',
            text: `¿Desea borrar el archivo "${row.carNombre}"? Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, borrar',
            cancelButtonText: 'Cancelar',
            preConfirm: async () => {
                setCargando(true);
                let url = '/archivo/borrararchivo';
                try {
                    const obj = { id: row.id, nombre: row.carNombre, usrRolid: rol };
                    const response = await apiService.post(url, obj, token);
                    if (response.status === 200) {
                        Mensaje('Borrar archivo', JSON.stringify(response.data));
                        onSubmit({ identificacion: idCabezaFamilia });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setCargando(false);
                }
            }
        });
    };
    async function VerPDF (row){
        setCargando(true);
        let url;
        url = '/archivo/downfilepdf';
        try {
            const obj = {idFile: row.id , nombre: row.carNombre, usrRolid: rol }
            const response = await apiService.getFile(url, obj, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = row.carNombre || 'downloaded-file.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Error', 'El archivo no se pudo encontrar');
            } else if(error.status === 409){
                Mensaje('Error', 'Conflicto al descargar el archivo');
            } else if (error.status === 404) {
                Mensaje('Error', 'El archivo no se pudo encontrar');
            } else {
                Mensaje('Error', error);
                console.error('Error fetching data:', error);
            }
        } finally {
            setCargando(false);
        }
    };
    useEffect(() => {
        if (idCabezaFamilia) {
            (async () => {
                await consultarCarpetaPersona(idCabezaFamilia);
            })();
        }
    }, [idCabezaFamilia]);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Cargar archivo</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to="/archivo/0">Archivo</NavLink></li>
                        <li className="breadcrumb-item active">Cargar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                            <div className="card-header">
                                <div className="card-tools">
                                    <div className="row">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="input-group">
                                                <input type='text' {...register('identificacion', { required: true })} className="form-control" placeholder="Identificacion"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-primary">Consultar persona</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {idCabezaFamilia !== '' && <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title m-0">Datos del Jefe de Hogar</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                    <div className="col-md-12">
                                        Nombre: <b>{nombre}</b>
                                    </div>
                                    </div>
                                    <div className="row">
                                    <div className="col-md-4">
                                        Identificacion: <b>{idCabezaFamilia}</b>
                                    </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'><p>Fecha creaci&oacute;n de la persona en el sistema: <b>{fechaCreacionCabeza.split('T')[0]}</b></p></div>
                                    </div>
                                </div>
                            </div>}
                            {idCabezaFamilia !== '' && !carpetaarchivo && <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-header">
                                        <h4 className="card-title m-0">No hay carpetas registradas para este hogar.</h4>
                                    </div>
                                    </div>
                            </div>}
                            {idCabezaFamilia !== '' && carpetaarchivo && <div className="card-header">
                                <div className='col-md-12'>
                                    <div className="card-header">
                                        <h4 className="card-title m-0">Agregar archivo</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label htmlFor="per_idpersona">Seleccionar integrante:</label>
                                                    <select
                                                        id="per_idpersona"
                                                        className="form-control"
                                                        {...register('per_idpersona', { required: true })}
                                                        defaultValue=""
                                                    >
                                                        <option value="" disabled>Seleccione un integrante</option>
                                                        {integrantes.map((integrante) => (
                                                            <option key={integrante.per_idpersona} value={integrante.per_idpersona}>
                                                                {integrante.per_idpersona} {integrante.nombre} {integrante.per_apellido1} {integrante.par_parentesco}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.per_idpersona && <p style={{ color: 'red' }}>Favor seleccione un integrante</p>}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label htmlFor="archivoInput">Archivo:</label>
                                                    <input id="archivoInput" className='form-control' type="file" onChange={handleFileChange} ref={ref}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <div className="form-group">
                                                    <label htmlFor="carArchivocentral">Archivo central:</label>
                                                    <select
                                                        id="carArchivocentral"
                                                        className="form-control"
                                                        value={carArchivocentral}
                                                        onChange={(e) => {setCarArchivocentral(e.target.value==='true'); setCarArchivoubicado(e.target.value?'':carArchivoubicado);}}
                                                    >
                                                        <option value="" disabled>Seleccione una opci&oacute;n</option>
                                                        <option value="true">S&iacute;</option>
                                                        <option value="false">No</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {!carArchivocentral && <div className='col-md-9'>
                                                <div className="form-group">
                                                    <label htmlFor="carArchivoubicado">Archivo ubicado:</label>
                                                    <input
                                                        id="carArchivoubicado"
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Ingrese ubicación del archivo"
                                                        value={carArchivoubicado}
                                                        onChange={(e) => setCarArchivoubicado(e.target.value)}
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <label htmlFor="observaciones">Observación</label>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                    <textarea rows={3} style={{ width: '100%' }}
                                                        {...register('observaciones', { required: true })}
                                                        value={observacion}
                                                        onChange={handleObservacion}
                                                        placeholder="Observaciones"
                                                    />
                                                    {errors.observaciones && <p style={{color: 'red'}}>Favor digite observación</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        <div className='row'>
                                            <div className='col-md-2'>
                                                <div className="btn-group w-100">
                                                    <span onClick={handleUpload} onKeyDown={(e) => e.key === 'Enter' && handleUpload()} className="btn btn-success col fileinput-button dz-clickable">
                                                        <FaUpload size={20} className="mr-2"/>
                                                        <span>Agregar archivo</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="envioBase64" checked={envioBase64} onChange={(e) => setEnvioBase64(e.target.checked)} />
                                                    <label className="form-check-label" htmlFor="envioBase64">
                                                        Enviar como Base64
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {/* /.card-header */}
                            {archivos.length > 0 && <div className="col-md-12">
                                <div className="card-body table-responsive p-0">
                                    <h5>Archivos cargados</h5>
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Id</th>
                                                <th>Observacion</th>
                                                <th>Fecha</th>
                                                <th>Nombre archivo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {archivos.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No hay datos para mostrar
                                                    </td>
                                                </tr>
                                            ) : (
                                                archivos.map((row, idx) => (
                                                    <tr key={row.id || idx}>
                                                        <td>
                                                            <div className="btn-group">
                                                                <BotonBorrar Borrar={BorrarArchivo} row={row} />
                                                                <BotonVerpdf Editar={VerPDF} row={row} />
                                                            </div>
                                                        </td>
                                                        <td>{row.id}</td>
                                                        <td>{row.carObservaciones}</td>
                                                        <td>{row.carFecha ? row.carFecha.split('T')[0] : ''}</td>
                                                        <td>{row.carNombre}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                    </div>
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                setSwalProps({})
            }}/>
                
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}